export var EActiveView;

(function (EActiveView) {
  EActiveView["PhoneAuth"] = "phoneAuth";
  EActiveView["PhoneAuthValidateSms"] = "phoneAuthValidateSms";
  EActiveView["PhoneAuthValidateCall"] = "phoneAuthValidateCall";
  EActiveView["PhoneCallOnboarding"] = "phoneCallOnboarding";
  EActiveView["AccountSelect"] = "accountSelect";
  EActiveView["ConfirmSelectedAccount"] = "confirmSelectedAccount";
  EActiveView["AccountSelectError"] = "accountSelectError";
  EActiveView["TokenExpiredError"] = "tokenExpiredError";
  EActiveView["AuthenticationRegistration"] = "authenticationRegistration";
  EActiveView["Agreement"] = "agreement";
  EActiveView["SocialCreate"] = "socialCreate";
  EActiveView["SocialMerge"] = "socialMerge";
  EActiveView["TwoFactor"] = "twoFactor";
  EActiveView["TwoFactorWithEmail"] = "twoFactorWithEmail";
  EActiveView["TwoFactorAttemptsExhausted"] = "twoFactorAttemptsExhausted";
  EActiveView["Restore"] = "restore";
  EActiveView["ConfirmPhone"] = "confirmPhone";
  EActiveView["EmailSent"] = "emailSent";
})(EActiveView || (EActiveView = {}));